import { useDispatch } from "react-redux";
import History from "../components/history/History";
import { useEffect } from "react";
import { historyActions } from "../store/history";
import { useUserTabEditPermissionDisabled } from "../lib/usersPermissions";
import { useNavigate } from "react-router-dom";

export default function HistoryPage() {
    const navigate = useNavigate()
    
    let historyPermission = useUserTabEditPermissionDisabled('history_view')    


    const dispatch = useDispatch()
    useEffect(() => {
        if (historyPermission != undefined && !historyPermission) {
            return navigate("/dashboard");
        }

        return () => {
            dispatch(historyActions.clearFilters())
            dispatch(historyActions.setCurrentPageData(null))
            dispatch(historyActions.setCurrentPage(1))
        }
    }, [])    

    
    return <History />
}